module.exports = __webpack_public_path__ + "static/media/example-work05.89d8300b.jpg";